import React, { useEffect, useState } from 'react';
import { stateToHTML } from 'draft-js-export-html';
import { stateFromHTML } from 'draft-js-import-html';
import { Editor, ContentState, EditorState, RichUtils, DraftHandleValue, convertFromHTML } from 'draft-js';
import LcIcon from '../../Generic/LcIcon';
import "./index.css";
import { PPDropDown } from 'processor-plataform-ui';
import { useSelector } from 'react-redux';
import { MenuState } from '../../../store/reducers/menuReducer';
import { RootState } from '../../../store/index';
import LcIconLink from '../../Generic/LcIconLink';

interface Props {
    label?: string,
    onChange: Function,
    value: any,
    openAttachment: Function,
    handleFiles?: Function
    files?: any,
    removeFiles?: Function,
    placeholder?: string
    // attendant?: boolean
    comment?: boolean
    setCommentType?: Function
    handleClick?: Function
    setToolbar?: Function
    emailTemplates?: any[]
    setCommentTemplateSelected?: Function
}

interface Option {
    label: any,
    value: string
}

const HHRichTextBoxDraftSolicitation: React.FC<Props> = (props) => {
    const menu = useSelector<RootState, MenuState>(state => state.menu);

    const [editorState, setEditorState] = useState(() => EditorState.createEmpty(),);
    // const [editorState, setEditorState] = useState(EditorState.createWithContent(defaultContent));
    const [showToolBar, setShowToolBar] = useState<boolean>(false);
    const [optionsValue, setOptionsValue] = useState("1")
    const [visualization, setVisualization] = useState(1)
    const [options, setOptions] = useState<Option[]>(
        // [
        //     {
        //         label: <span className={"spanOrderIconCommentType"}>
        //             <i className="ppi ppi-eye-off iconCommentType" />
        //             Visivel para o atendente somente
        //         </span>,
        //         value: "0"
        //     },
        //     {
        //         label: <span className={"spanOrderIconCommentType"}>
        //             <i className="ppi ppi-eye iconCommentType" />
        //             Visivel para o solicitante
        //         </span>,
        //         value: "1"
        //     },
        //     {
        //         label: <span className={"spanOrderIconCommentType"}>
        //             <i className="ppi ppi-mail-open iconCommentType" />
        //             Enviar e-mail padrão para o cliente
        //         </span>,
        //         value: "3"
        //     }
        // ]
    )

    const [emailTemplateSelected, setEmailTemplateSelected] = useState<any>(undefined);
    const [emailTemplates, setEmailTemplates] = useState<any[]>([]);

    const mountDropList = (list: any[]) => {
        let result = (list.length === 1) ? [] : [{ label: "Modelo padrão", value: '0' }];

        if (list.length > 0) {
            let _list = list.filter(c => (c.disabled) ? c.disabled === 0 || c.disabled === false : c)
                .map(c => { return { label: c.description, value: c.id } })
                .sort((a, b) => { return a.label > b.label ? 1 : -1 })

            return [..._list];
        }
        else {
            return result;
        }
    }

    useEffect(() => {
        if (props.emailTemplates && props.emailTemplates.length > 0) {
            setEmailTemplates(mountDropList(props.emailTemplates));
        }
    }, [props.emailTemplates])

    useEffect(() => {
        if (props.value) {
            const contentState = EditorState.createWithContent(stateFromHTML(props.value));
            setEditorState(contentState);
        }
    }, []);

    const [optionsFormmatType, setOptionsFormmatType] = useState<any>({
        bold: false,
        italic: false,
        strikeThrough: false,
    });

    const onBoldClick = (e) => {
        e.preventDefault();
        setEditorState(RichUtils.toggleInlineStyle(editorState, 'BOLD'));
        setOptionsFormmatType({
            ...optionsFormmatType,
            bold: !optionsFormmatType.bold
        });
    }

    const onItalicClick = (e) => {
        e.preventDefault();
        setEditorState(RichUtils.toggleInlineStyle(editorState, 'ITALIC'));
        setOptionsFormmatType({
            ...optionsFormmatType,
            italic: !optionsFormmatType.italic
        });
    }

    const onUnderlineClick = (e) => {
        e.preventDefault();
        setEditorState(RichUtils.toggleInlineStyle(editorState, 'UNDERLINE'));

    }

    const onStrikeThroughClick = (e) => {
        e.preventDefault();
        setEditorState(RichUtils.toggleInlineStyle(editorState, 'STRIKETHROUGH'));
        setOptionsFormmatType({
            ...optionsFormmatType,
            strikeThrough: !optionsFormmatType.strikeThrough
        });
    }

    const handleKeyCommand = (command, editorState) => {
        const newState = RichUtils.handleKeyCommand(editorState, command);

        if (newState) {
            setEditorState(newState);
            return 'handled';
        }

        return 'not-handled';
    }

    const handleChange = (e: any) => {
        setEditorState(e);
        (props.comment)
            ? props.onChange(editorState)
            : props.onChange(stateToHTML(editorState.getCurrentContent()));
    }

    const handleFiles = (files: Blob[], event?: any,): DraftHandleValue => {
        if (files && props.handleFiles) {
            props.handleFiles(files)
            return "handled";
        }
        else {
            return "not-handled";
        }
    }

    useEffect(() => {
        props.setCommentType && props.setCommentType(visualization)

    }, [visualization])
    // setOptionsValue(event.target.value)

    // if (event.target.value !== "3") {
    //     setEmailTemplateSelected(undefined);
    // }


    const handleClick = () => {
        if (stateToHTML(editorState.getCurrentContent()) !== '<p><br></p>') {
            props.handleClick && props.handleClick(editorState)
        }
        else if (props.files.length > 0) {
            props.handleClick && props.handleClick(undefined)
        }
    }

    useEffect(() => {
        props.setToolbar && props.setToolbar(showToolBar);
    }, [showToolBar])

    const handleChangeTemplate = (event: any) => {
        const { value } = event.target;
        const emailTemplate = props.emailTemplates && props.emailTemplates.find(x => x.id === Number(value));
        setEmailTemplateSelected(emailTemplate);
    }

    useEffect(() => {
        if (emailTemplateSelected) {
            const emailText = EditorState.createWithContent(
                ContentState.createFromBlockArray(
                    convertFromHTML(emailTemplateSelected.text)));

            setEditorState(emailText);
            props.setCommentTemplateSelected && props.setCommentTemplateSelected(emailTemplateSelected);
        }
        else {
            props.setCommentTemplateSelected && props.setCommentTemplateSelected(undefined);
        }
    }, [emailTemplateSelected])

    const getWidthTextBox = () => {
        if (showToolBar) {
            return "calc(100% - 1px)";
        }
        else {
            return "calc(100% - 1px)";
        }
        // }
    }
    const handleRemoveFiles = (files) => {
        props.removeFiles && props.removeFiles(files);
    }

    const Attachments = () => {
        const removeFile = (index: number) => {
            const updatedFiles = [...props.files];
            updatedFiles.splice(index, 1);

            handleRemoveFiles(updatedFiles);
        };

        const formatBytes = (bytes, decimals = 2) => {
            if (bytes === 0) return '0 Bytes';

            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['Bytes', 'KB', 'MB'];

            const i = Math.floor(Math.log(bytes) / Math.log(k));

            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        }

        return (
            <>
                {
                    props.files && props.files.length > 0 &&
                    <div className={"divOrderAttachmentComments"} style={{ width: "100%" }}>
                        {
                            props.files && props.files.map((file, index) => {
                                let size = formatBytes(file.size);

                                return (
                                    <div className='divShowfile' >
                                        <LcIcon
                                            icon={"ppi ppi-paper-clip"}
                                            size={"small"}
                                            color={'#898DA6'}
                                        />
                                        <div className="divOrderAttachmentShowCommentSolicitation">
                                            <span className={"spanLabelCommentSolicitation"}>{file.name}</span>
                                            <span className={"spanSize"}>{size}</span>
                                        </div>
                                        <LcIconLink
                                            icon={"ppi ppi-x"}
                                            tooltip={"Remover"}
                                            size={"small"}
                                            onClick={() => removeFile(index)}
                                            color={"red"}
                                        />
                                    </div>
                                )
                            })
                        }
                    </div>

                }
            </>
        )
    }

    const pasteImage = async (event) => {
        if (props.handleFiles) {
            var item = event.clipboardData?.items[0];

            if (item && item.type.indexOf("image") === 0) {
                var blob = item.getAsFile();
                var reader = new FileReader();

                blob && reader.readAsDataURL(blob);
                props.handleFiles([blob]);
            }
        }
    }

    return (
        <>
            <Attachments />
            <div className={`divOrderRichTextBox`}
                style={{
                    width: (window.screen.width > 600) ? getWidthTextBox() : '100%',
                    flexDirection: (showToolBar) ? "column" : "row",
                    flexWrap: (showToolBar) ? "wrap" : "nowrap",
                    height: (window.screen.width < 600) ? "" : (!showToolBar) ? '50px' : "196px",
                    display: 'flex',
                    alignItems: 'center'

                }}
            >
                {
                    window.screen.width > 600 &&
                    <div
                        className={"divOrderRichTextButtons"}
                        style={{
                            width: (!showToolBar) ? "100px" : "100%",
                            display: 'flex',
                            alignContent: 'center',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            height: '50px',
                        }}>
                        <div style={{ display: 'flex', marginLeft: '20px' }}>
                            <div className='btnIconsNew'>
                                <i
                                    className={`anexoHoverTextbox ${(!showToolBar) ? "ppi ppi-chevron-up" : "ppi ppi-chevron-down"}`}
                                    onClick={() => setShowToolBar(!showToolBar)}
                                    style={{ fontSize: '25px', marginRight: '10px' }}
                                />
                                <i
                                    className={"anexoHoverTextbox ppi ppi-paper-clip"}
                                    onClick={() => props.openAttachment(true)}
                                    style={{ fontSize: '25px' }}
                                />
                            </div>

                            {/* {
                            props.attendant && showToolBar &&
                            <LcIcon
                                tooltip={visualization === 1 ? 'Mostrar para solicitantte' : 'Mostrar para atendente'}
                                icon={visualization === 1 ? 'anexoHoverTextbox ppi ppi-eye' : 'anexoHoverTextbox ppi ppi-eye-off'}
                                onClick={() => visualization === 0 ? setVisualization(1) : setVisualization(0)}
                            />
                        } */}
                            {
                                emailTemplates.length > 0 && showToolBar &&
                                <PPDropDown
                                    options={emailTemplates}
                                    value={emailTemplateSelected && emailTemplateSelected.id}
                                    name={"emailTemplateId"}
                                    onChange={handleChangeTemplate}
                                    width={"25vw"}
                                    placeholder={'Modelo padrão'}
                                />
                            }
                            {
                                showToolBar &&
                                <>
                                    <LcIcon icon={"ppi ppi-divider-vertical"} color={"#B5B7C6"} />
                                    <button
                                        className={"buttonTextBox"}
                                        onClick={(e) => onBoldClick(e)}
                                        style={{
                                            backgroundColor: (optionsFormmatType.bold) ? 'lightskyblue' : 'white'
                                        }}
                                    > B </button>
                                    <button
                                        className={"buttonTextBox buttonTextBoxItalic"}
                                        onClick={(e) => onItalicClick(e)}
                                        style={{
                                            backgroundColor: (optionsFormmatType.italic) ? 'lightskyblue' : 'white'
                                        }}
                                    > I </button>
                                    {/* <button className={"buttonTextBox buttonTextBoxUnderline"} onClick={(e) => onUnderlineClick(e)}> U </button> */}
                                    <button
                                        className={"buttonTextBox buttonTextBoxStrikethrough"}
                                        onClick={(e) => onStrikeThroughClick(e)}
                                        style={{
                                            backgroundColor: (optionsFormmatType.strikeThrough) ? 'lightskyblue' : 'white'
                                        }}
                                    > S </button>
                                </>
                            }

                        </div>

                        <div className='btnEnviar'>
                            <button
                                className={"lc-button small bg-info buttonAddDestinatarios"}
                                style={{
                                    marginRight: '10px',
                                    width: "100px",
                                    position: (showToolBar) ? "initial" : 'absolute',
                                    right: "0px",
                                    top: (showToolBar) ? "0" : '5px',
                                }}
                                onClick={handleClick}
                            > Enviar </button>
                        </div>
                    </div>
                }

                <div
                    className={`textBoxEditorSolicitation`}
                    style={{
                        // minHeight: window.screen.width > 600 ? (showToolBar) ? "100px" : "50px" : '50px',
                        // maxHeight: window.screen.width > 600 ? (showToolBar) ? "150px" : "50px" : '50px',
                        // overflowY: "auto",
                        overflowY: (!showToolBar) ? "hidden" : 'auto',
                        overflowX: "hidden",
                        overflow: (window.screen.width < 600) ? "auto" : "hidden",
                        width: (!showToolBar) ? "calc(100% - 215px)" : '100%',
                        height: (window.screen.width < 600) ? "" : (!showToolBar) ? '45px' : "145px",
                        // display: (!showToolBar) ? 'flex' : "initial",
                        display: "flex",
                        alignItems: 'flex-start',
                        border: (window.screen.width > 600) ? '1px solid gray' : 'none',
                        borderRadius: '5px',
                        alignContent: 'center',
                        paddingTop: "10px",
                    }}
                    onClick={() => (window.screen.width > 600 && props.comment) ? setShowToolBar(true) : ''}
                    onPaste={pasteImage}
                >
                    <Editor
                        // onFocus={() => props.comment ? setShowToolBar(true) : ''}
                        editorState={editorState}
                        onChange={setEditorState}
                        // style={{ 
                        //     display: (!showToolBar) ? 'flex' : "initial",
                        //  }}
                        // handleKeyCommand={handleKeyCommand}
                        // handleDroppedFiles={(e, file) => handleFiles(file, e)}
                        // handlePastedFiles={(e) => handleFiles(e)}
                        placeholder={props.placeholder}
                    />
                </div>

                <div>
                    {
                        window.screen.width < 600 &&
                        // <div className='btnIcons'>
                        //     <i aria-disabled className={"anexoHoverTextbox ppi ppi-paper-clip"} onClick={() => props.openAttachment(true)} />
                        //     <i aria-disabled className='anexoHoverTextbox ppi ppi-paper-airplane'
                        //         style={{ opacity: stateToHTML(editorState.getCurrentContent()) !== '<p><br></p>' ? '1' : '0.3' }}
                        //         onClick={handleClick} ></i>


                        // </div>

                        // <div className={"btnIcons"}>
                        <div className='btnIconsNew'>
                            <i
                                aria-disabled
                                className={"anexoHoverTextbox ppi ppi-paper-clip"}
                                style={{ fontSize: '20px' }}
                                onClick={() => props.openAttachment(true)}
                            />
                            <i
                                aria-disabled
                                className={"anexoHoverTextbox ppi ppi-paper-airplane"}
                                style={{ opacity: stateToHTML(editorState.getCurrentContent()) !== '<p><br></p>' ? '1' : '0.3', fontSize: '20px' }}
                                onClick={handleClick}
                            />

                            {/* <i className={"anexoHoverTextbox ppi ppi-paper-clip"} onClick={() => props.openAttachment(true)} /> */}
                        </div>
                    }
                </div>
            </div>
        </>
    );
};

export default HHRichTextBoxDraftSolicitation;